module.exports = __webpack_public_path__ + "static/media/scissors-dark_thumbnail.f7567850.png";